import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';

@Injectable()
export class EditAppsModalService {

  app: any;
  delete = new Subject();

  constructor() {

  }

}
